import { useQuery } from "@tanstack/react-query";
import plansAdminService from "services/admin/plansService";
import { Plan } from "interfaces/entities/plan.interface";

export const useGetPlanDetails = (id: string) => {
    return useQuery({
        queryKey: ['plan', id],
        queryFn: async () => {
            const response: any = await plansAdminService.get(id)
            return response.data as Plan
        }
    })
}